<template>
  <v-sheet
    tabindex="0"
    rounded
    title="Arrasta o selecciona el archivo"
    color="#e7e7e7"
    class="rounded-xl"
    v-bind:style="[
      this.dragover
        ? { cursor: 'pointer', border: '3px dotted #4b3b72' }
        : { cursor: 'pointer' },
    ]"
    width="100%"
    height="120"
  >
    <input type="file" style="display: none" :accept="extensions" :multiple="multiple"/>

    <v-row>
      <v-col class="text-center">
        <span
          style="
            font-size: 20px !important;
            color: #4b3b72 !important;
            font-weight: bold;
          "
          >{{ getLabel() }}</span
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <i
          v-if="!dragover"
          class="mdi mdi-cloud-upload-outline size-dragover mt-10"
          color="primary"
        />

        <i
          v-if="dragover"
          color="primary"
          class="mdi mdi-book-plus size-dragover mt-10"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="text-primary texto-upload">
      <span class="title"></span>
    </v-row>

    <popup
      width="370px"
      titulo="Enviar"
      :texto="`¿Desea enviar el fichero <b>${filename}</b>?`"
      confirmar="Si"
      cancelar="No"
      :dialog="dialog"
      @close="
        dialog = false;
        files = null;
        dragover = false;
      "
      @ok="filesSelected()"
    />

    <popup
      :dialog="dialogInfo"
      width="370px"
      titulo="Información"
      texto="El tamaño máximo del fichero es de 5MB"
      confirmar="Ok"
      @ok="dialogInfo = false"
      @close="dialogInfo = false"
    />
  </v-sheet>
</template>

<script>
import { Utilidades } from "@/Util/Utilidades";
import Popup from "./Popup.vue";
export default {
  components: { Popup },
  props: {
    extensions: {
      type: String,
      default: ".jpg, .jpeg, .png, .webp",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    label: String,
  },
  data: function () {
    return {
      dragover: false,
      formUpload: false,
      dialog: false,
      dialogInfo: false,
      filename: "",
      files: null,
    };
  },
  mounted() {
    const dropzone = this.$el;
    const fileupload = this.$el.firstElementChild;

    if (dropzone)
      dropzone.addEventListener("dragenter", (e) => {
        e.preventDefault();
        this.dragover = true;
      });

    dropzone.addEventListener("dragleave", (e) => {
      e.preventDefault();
      this.dragover = false;
    });

    dropzone.addEventListener("dragover", (e) => {
      e.preventDefault();
      this.dragover = true;
    });

    dropzone.addEventListener("drop", (e) => {
      e.preventDefault();
      const dravevent = e;
      if (dravevent.dataTransfer) {
        this.files = dravevent.dataTransfer.files;
        this.filename = dravevent.dataTransfer.files[0].name;
        this.dialog = true;
      }
    });

    dropzone.addEventListener("click", (e,v) => {
      // e.preventDefault()
      if (fileupload) {
        fileupload.click();
      }
    });
    dropzone.addEventListener("keypress", (e) => {
      e.preventDefault();
      const keyEvent = e;
      if (keyEvent.key === "Enter") {
        if (fileupload) fileupload.click();
      }
    });
    // register listeners on the file input
    if (fileupload) {
      fileupload.addEventListener("change", (e) => {
        const target = e.target;
        if (target.files) {
          //5MB
          if (target.files[0].size > 5242880) {
            this.dialogInfo = true;
            return;
          }

          this.files = target.files;
          this.filename = target.files[0].name;
          this.dialog = true;
        }
      });
    }
  },
  methods: {
    filesSelected() {
      this.filename = this.files.filename;
      this.files.filename = this.files[0].name;
      this.$emit("send", this.files);
      this.dragover = false;
      this.dialog = false;
      this.files = null;
    },
    getStyle() {
      if (!this.dragover) return "cursor: pointer; border: 3px dotted #4b3b72";
      else return "cursor: pointer;";
    },
    getLabel() {
      if (Utilidades.isNullOrUndefinedOrEmpty(this.label))
        return "Arrasta o selecciona el archivo";
      else return this.label;
    },
  },
};
</script>
<style>
@media screen and (max-width: 3400px) {
  .size-dragover {
    font-size: 75px !important;
    color: #4b3b72 !important;
    margin-bottom: -30px !important;
  }

  /* .texto-upload span:after {
    content: "Clique ou arraste a Imagem" !important;
  } */
}

@media screen and (max-width: 1200px) {
  .size-dragover {
    font-size: 75px !important;
    color: #4b3b72 !important;
    margin-bottom: -30px !important;
  }

  /* .texto-upload span:after {
    content: "Clique ou arraste a Imagem" !important;
  } */
}

@media screen and (max-width: 1024px) {
  .size-dragover {
    font-size: 75px !important;
    color: #4b3b72 !important;
    margin-bottom: -30px !important;
  }

  /* .texto-upload span:after {
    content: "Clique ou arraste a Imagem" !important;
  } */
}

@media screen and (max-width: 768px) {
  .size-dragover {
    font-size: 45px !important;
    color: #4b3b72 !important;
    margin-bottom: -10px !important;
  }

  /* .texto-upload span:after {
    content: "Clique para upload" !important;
  } */
}

@media screen and (max-width: 480px) {
  .size-dragover {
    font-size: 45px !important;
    color: #4b3b72 !important;
    margin-bottom: -10px !important;
  }

  /* .texto-upload span:after {
    content: "Clique para upload" !important;
  } */
}
</style>